import React, { useState, useEffect } from 'react';
import { Upload, Button, Alert, Space, Col, Row, Spin, Card } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import { PDF_MODIFIED, SAVE_NEW_CONTRACT_PDF } from '../../state/lease_contract/types';
import { RESOURCE } from '../../config/constants/alerts';
import { STATUS } from '../../config/constants/states';
import PropTypes from 'prop-types';

const UploadPdf = ({ uploadContractPdf, id, isUpdated, resetStatus }) => {

  const [contractData, setContractData] = useState(null);
  const [spinner, setSpinner] = useState(false);

  useEffect(() => {
    if (isUpdated !== STATUS.PENDING) {
      setContractData(null);
      setSpinner(false);
      resetStatus();
    }
  }, [isUpdated]);

  const dummyRequest = ({ onSuccess }) => {
    setTimeout(() => {
      onSuccess('ok');
    }, 0);
  };

  const uploadProps = {
    accept: 'application/pdf',
    action: (file) => {
      const reader = new FileReader();
      reader.onload = function (fileLoadedEvent) {
        const base64 = fileLoadedEvent.target.result;
        const data = {};
        data.docID = id;
        data.pdf = base64.replace('data:application/pdf;base64,', '');
        setContractData({ ...data });
      };
      reader.readAsDataURL(file);
    },
    showUploadList: false,
  };

  return (
    <Card style={{ width: '100%'}}>
      <Col lg={24} md={24}>
        <Row className="justify-content-center mb-3">
          <Upload {...uploadProps} customRequest={dummyRequest} maxCount={1}>
            <Button icon={<UploadOutlined />}>Cargar contrato editado como PDF</Button>
          </Upload>
        </Row>
      </Col>
      {contractData && (
        <Col span={24} className="mt-3" >
          <Spin spinning={spinner} tip="Actualizando contrato...">
            <Alert
              showIcon
              type="warning"
              message="Advertencia"
              description="Esta acción reemplazará al contrato original. 
                            Un contrato editado manualmente no puede volver a ser editado por ningún participante a través de 
                            la plataforma, de ahora en adelante, cada vez que desee editar este contrato deberá ser descargado, 
                            editado y cargado nuevamente de forma manual por un administrador."
              action={
                <Space direction="vertical">
                  <Button size="small" type="danger" onClick={() => { uploadContractPdf(contractData); setSpinner(true); }}>
                    Cargar contrato editado
                  </Button>
                  <Button size="small" primary type="ghost" onClick={() => setContractData(null)}>
                    Cancelar
                  </Button>
                </Space>
              }
            />
          </Spin>
        </Col>
      )}
    </Card>
  );
};

UploadPdf.propTypes = {
  id: PropTypes.string.isRequired,
  uploadContractPdf: PropTypes.func.isRequired,
  isUpdated: PropTypes.string.isRequired,
  resetStatus: PropTypes.func.isRequired,
};

const data = (state) => ({
  isUpdated: state.contract.isUpdated,
});

const actions = (dispatch) => ({
  uploadContractPdf: (data) => dispatch({ type: SAVE_NEW_CONTRACT_PDF, payload: { ...data, resource: RESOURCE.SAVE_NEW_CONTRACT_PDF } }),
  resetStatus: () => dispatch({ type: PDF_MODIFIED, payload: STATUS.PENDING })
});

export default connect(data, actions)(UploadPdf);